


























































































































































































import {
  defineComponent, ref, computed, onMounted, onBeforeUnmount, defineAsyncComponent,
} from '@vue/composition-api';
import {
  Tabs, TabItem as Tab, Radio,
  Button,
  Dialog,
} from '@hb/coffee';
import { ForceReadService } from '@/widgets/right-contract';
import { RightArrowOutline12 } from '@hb/coffee-icons';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';

import {
  calcWithOrder, getStuckContract, applyStuckOrder,
} from '@/api/ordersV2';
import { CalcSceneEnum, MoreCapitalResItem } from '@/api/ordersV2/types';
import type { RepayDialogDataType } from '@/components/finance-replan/types';
import { getRightsSummary } from '@/api/rights';
import { RightPackageTypeEnum, RightSummaryType, RightPackageSourceEnum } from '@/api/rights/types';
import { MembersRightsPrefix } from '@/constant';
import { MemberRouterNameEnum } from '@/shared/right-utils/routerName';
import URLUtils from '@/shared/utils/URLUtils';
import { RouterV2Enum } from '@/router/router-names';
import { EquityPathType } from '@/api/apply-product/types';
import { ubtSendError } from '@/shared/utils/ubt';
import {
  cardLimitPageExpose,
  cardLimitPageCapitalModuleClick,
  cardLimitPageLoanAgreementModuleClick,
  cardLimitPageRepaymentModuleClick,
  cardLimitPageRightsDetailClick,
  cardLimitPageRightsAgreement,
  cardLimitPageRightsAgreementCheck,
  cardLimitPageButton,
  cardLimitPageLoanAgreementPopClick,
  cardLimitPageLoanAgreementPopExpose,
  cardLimitPageErrorPopExpose,
  cardLimitPageErrorPopClick,
} from './tianqi';


// 异步引入组件
const FinanceReplan = defineAsyncComponent(() => import('@/components/finance-replan/index.vue'));
const ForceAgreementView = defineAsyncComponent(() => import('@/views_v2/withdrawal-waiting/components/force-agreement-view/index.vue'));
const BaseAgreementView = defineAsyncComponent(() => import('@/views_v2/withdrawal-waiting/components/base-agreement-view/index.vue'));
const DetailPagePopup = defineAsyncComponent(() => import('@/views_v2/apply-product/components/rights/zhenxiang-card/components/rights-popup'));


export default defineComponent({
  name: 'WithdrawalWaiting',
  components: {
    FinanceReplan,
    ForceAgreementView,
    BaseAgreementView,
    DetailPagePopup,
    Tab,
    Tabs,
    RightArrowOutline12,
    Radio,
    Button,
  },
  props: {
    loanOrderId: {
      type: String,
      required: true,
    },
    capitalCode: {
      type: String,
      required: true,
    },
  },
  setup(props, context) {
    const router = context.root.$router;
    /** 协议预览注册 */
    const {
      handleForceRead,
    } = ForceReadService({
      packageType: RightPackageTypeEnum.CHANNEL_B,
      forceReadFromScene: RightPackageSourceEnum.LOAN_APPLY,
    });
    const contractListRef = ref<HTMLDivElement | null>(null);
    const selected = ref(0);
    // 响应式数据
    const institutionList = ref<MoreCapitalResItem[]>([]);

    const currentInstitutionIndex = ref(0);
    const currentAgreementIndex = ref(0);
    const countDown = ref(5);
    const isAgreementChecked = ref(false);
    const showReplan = ref(false);
    const showForceRead = ref(false);
    const showBaseAgreement = ref(false);
    const showDetailPopup = ref(false);
    const repayDialogData = ref<RepayDialogDataType>();
    const rightParams = ref<RightSummaryType>();
    const rightsUrl = ref('');
    const loanAmount = ref(0);
    const loanPeriod = ref(0);
    const productId = ref<string | number>('');
    const productName = ref<string>('');
    const rightsCheckTipsShow = ref(false);
    // 防重提交状态
    const isSubmitting = ref(false);

    // 定时器
    let timer: number | null = null;

    // 计算属性
    const currentAgreementList = computed(() => institutionList
      .value[currentInstitutionIndex.value]?.contractList || []);

    const serialCapitalName = computed(() => institutionList.value.map((it) => it.productName).join('、'));


    const sellPrice = computed(() => rightParams.value?.sellPrice || '');

    const getTqParams = () => {
      const { packageId, supplierCode } = rightParams.value || {};
      const { rateType } = repayDialogData.value || {};
      // 综合利率
      return {
        packageId: packageId || '',
        sellPrice: sellPrice.value || '',
        supplierCode: supplierCode || '',
        productId: productId.value || '',
        rateType: rateType || '',
        capitalCode: props.capitalCode || '',
        rateValue: repayDialogData.value?.rateValue || '',
      };
    };

    const ubtParams = computed(() => getTqParams());
    const remindFunction = () => {
      // 兜底协议模块点击申请埋点
      ubtSetupModuleExpose(cardLimitPageErrorPopExpose, ubtParams.value);
      // 错误告警，js sendRequestError(error);
      /** 接口异常场景，弹窗提示刷新 */
      Dialog.alert({
        title: '提示',
        message: '页面部分数据加载异常，请点击刷新按钮获取页面完整数据',
        confirmButtonText: '刷新',
        closeable: false,
      }).then(() => {
        ubtSetupPageButton(cardLimitPageErrorPopClick, ubtParams.value);
        window.location.reload();
      });
    };

    // 获取合同名称的安全方法
    const getContractName = () => {
      // 参数存在性检查
      if (!rightParams.value?.contractInfo?.name) {
        return '《会员综合协议》';
      }
      return `《${rightParams.value.contractInfo.name}》`;
    };

    const changeInstitution = (index: number, tab: any) => {
      // 资方模块点击埋点
      ubtSetupPageButton(cardLimitPageCapitalModuleClick, {
        ...ubtParams.value,
        Name: tab && tab.title,
      });
      selected.value = index;
      currentInstitutionIndex.value = index;
      currentAgreementIndex.value = 0;
      if (contractListRef.value) {
        contractListRef.value.scrollTo(0, 0);
      }
    };

    const changeAgreementIndex = (index: number) => {
      currentAgreementIndex.value = index;
    };

    const previewContract = async () => {
      // 查看权益协议埋点
      ubtSetupPageButton(cardLimitPageRightsAgreement, ubtParams.value);
      await handleForceRead({
        contractScene: rightParams.value?.contractInfo?.scene || '',
        preview: true,
      });
    };

    const handleBaseAgreementClick = (index: number) => {
      // 提现协议模块点击埋点
      ubtSetupPageButton(cardLimitPageLoanAgreementModuleClick, {
        ...ubtParams.value,
        Name: currentAgreementList.value[index].name,
      });
      currentAgreementIndex.value = index;
      showBaseAgreement.value = true;

      // 兜底协议模块点击申请埋点
      ubtSetupModuleExpose(cardLimitPageLoanAgreementPopExpose, ubtParams.value);
    };

    const showRepaymentPlan = async () => {
      // 还款计划模块点击埋点
      ubtSetupPageButton(cardLimitPageRepaymentModuleClick, ubtParams.value);

      if (!repayDialogData.value) {
        repayDialogData.value = await calcWithOrder({
          loanOrderId: props.loanOrderId,
          capitalCode: props.capitalCode,
          calcScene: CalcSceneEnum.STUCK_ORDER,
        });
      }
      showReplan.value = true;
    };

    const showPriorityChannel = () => {
      // 权益详情入口点击埋点
      ubtSetupPageButton(cardLimitPageRightsDetailClick, ubtParams.value);
      // 显示优先审核通道详情弹窗
      showDetailPopup.value = true;

      // 构建权益详情URL
      rightsUrl.value = URLUtils.formatUrl(
        `${MembersRightsPrefix}${
          MemberRouterNameEnum.ZHENXIANG_CARD
        }.html#/${
          MemberRouterNameEnum.ZHENXIANG_CARD
        }`,
        {
          packageId: rightParams.value?.packageId,
          capitalCode: institutionList.value[currentInstitutionIndex.value]?.capitalCode,
          from: RightPackageSourceEnum.LOAN_APPLY_STUCK,
          hiddenPayButton: true,
        },
      );
    };

    const onDetailPopupClose = () => {
      showDetailPopup.value = false;
    };

    const toggleAgreementCheck = () => {
      isAgreementChecked.value = !isAgreementChecked.value;
      // 当勾选时隐藏提示
      if (isAgreementChecked.value) {
        // 勾选权益协议按钮埋点
        ubtSetupPageButton(cardLimitPageRightsAgreementCheck, ubtParams.value);
        rightsCheckTipsShow.value = false;
      }
    };

    const jumpToApplyResult = (loanOrderId: string) => {
      router.replace({
        path: RouterV2Enum.applyResult,
        query: {
          orderId: String(loanOrderId) || '',
          commodityId: String(productId.value),
          commodityName: String(productName.value),
        },
      });
    };

    const applyLoanOrder = async () => {
      // 设置防重提交状态
      isSubmitting.value = true;

      try {
        // 参数存在性检查
        if (!props.loanOrderId || !props.capitalCode) {
          remindFunction();
        }

        if (!repayDialogData.value) {
          remindFunction();
        }

        if (!rightParams.value) {
          remindFunction();
        }

        const { loanOrderId } = await applyStuckOrder({
          loanOrderId: props.loanOrderId,
          capitalCode: props.capitalCode,
          interestDisplay: String(repayDialogData.value?.rateValue) || '',
          loanApplyMarketReq: {
            packageType: RightPackageTypeEnum.CHANNEL_B,
            packageId: rightParams.value?.packageId || '',
            packageFrom: RightPackageSourceEnum.LOAN_APPLY_STUCK,
            expectPrice: rightParams.value?.sellPrice || 0,
            equityPath: EquityPathType.BUY_RIGHTS,
          },
        });
        if (loanOrderId) {
          /** 跳转申请结果页 */
          jumpToApplyResult(loanOrderId);
        }
      } catch (error) {
        // 提交失败时重置防重状态
        isSubmitting.value = false;
        throw error;
      }
    };

    const handleAgreementApplyClick = () => {
      if (countDown.value > 0) return;

      // 防重提交检查
      if (isSubmitting.value) {
        return;
      }

      // 兜底协议模块点击申请埋点
      ubtSetupPageButton(cardLimitPageLoanAgreementPopClick, ubtParams.value);
      applyLoanOrder();
    };

    /** 同意协议并提交 */
    const handleApply = () => {
      if (!isAgreementChecked.value) {
        rightsCheckTipsShow.value = true;
        return;
      }

      // 防重提交检查
      if (isSubmitting.value) {
        return;
      }

      // 提交权益订单埋点
      ubtSetupPageButton(cardLimitPageButton, ubtParams.value);
      /** 显示强制阅读弹窗 */
      showForceRead.value = true;
      // 兜底协议模块点击申请埋点
      ubtSetupModuleExpose(cardLimitPageLoanAgreementPopExpose, ubtParams.value);
      /** 强制阅读倒计时 */
      timer = window.setInterval(() => {
        if (countDown.value > 0) {
          countDown.value -= 1;
        }
      }, 1000);
    };


    /** 获取权益信息 */
    const getRightsInfo = async () => {
      rightParams.value = await getRightsSummary({
        productId: String(productId.value),
        orderAmount: Number(loanAmount.value),
        period: Number(loanPeriod.value),
        packageType: RightPackageTypeEnum.CHANNEL_B,
      });
    };

    /** 获取还款计划 */
    const getRepayPlan = async () => {
      repayDialogData.value = await calcWithOrder({
        loanOrderId: props.loanOrderId,
        capitalCode: props.capitalCode,
        calcScene: CalcSceneEnum.STUCK_ORDER,
      });
    };

    // 获取兜底资方信息
    const getMoreCapitalInfo = async () => {
      const {
        contractResList, loanApplyAmount,
        loanApplyPeriod, productId: productIdRes, productName: productNameRes,
      } = await getStuckContract(
        {
          loanOrderId: props.loanOrderId,
          capitalCode: props.capitalCode,
        },
      );
      if (loanApplyAmount) {
        loanAmount.value = loanApplyAmount;
      }
      if (loanApplyPeriod) {
        loanPeriod.value = loanApplyPeriod;
      }
      if (productIdRes) {
        productId.value = productIdRes;
      }
      if (productNameRes) {
        productName.value = productNameRes;
      }

      if (contractResList && contractResList.length > 0) {
        institutionList.value = contractResList.map((item) => ({
          productId: item.productId,
          productName: item.productName || '',
          productIcon: item.productIcon,
          contractList: item.contractList || [],
        }));
      }
    };

    // 生命周期
    onMounted(async () => {
      /** 先请求这个接口，获取到渠道id 、渠道名称、提现金额、提现期数，后面权益接口依赖这些信息 */
      await getMoreCapitalInfo().catch((error) => {
        ubtSendError('getMoreCapitalInfo fail');
        remindFunction();
      });
      // 获取资方信息、权益信息、还款计划
      await Promise.all([
        getRightsInfo(),
        getRepayPlan(),
      ]).catch((error) => {
        ubtSendError('getRightsInfo getRepayPlan fail');
        remindFunction();
      });

      // 卡单页曝光埋点，接口返回以后再上报
      ubtSetupModuleExpose(cardLimitPageExpose, ubtParams.value);
    });

    onBeforeUnmount(() => {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
      // 重置防重提交状态
      isSubmitting.value = false;
    });

    return {
      contractListRef,
      institutionList,
      currentInstitutionIndex,
      currentAgreementIndex,
      countDown,
      isAgreementChecked,
      showReplan,
      showForceRead,
      showBaseAgreement,
      showDetailPopup,
      repayDialogData,
      rightsUrl,
      loanAmount,
      loanPeriod,
      rightsCheckTipsShow,
      isSubmitting,
      currentAgreementList,
      serialCapitalName,
      changeInstitution,
      changeAgreementIndex,
      handleBaseAgreementClick,
      showRepaymentPlan,
      showPriorityChannel,
      toggleAgreementCheck,
      onDetailPopupClose,
      handleApply,
      handleAgreementApplyClick,
      sellPrice,
      getContractName,
      previewContract,
    };
  },
});
